import React from 'react';
import { Col, Container, Image } from 'react-bootstrap';

const GameBundle = () => {
  

    return (
        <>
            <Container>
                <Col xs={12} lg={8} className='mx-auto'>
                    <div className="text-center rzr-section mb-1 mt-4">
                        <h1 className='text-white headingtext text-wrap mb-0'>
                            SCORE A BLACK OPS 6 CORSAIR PC BATTLE STATION BUNDLE
                        </h1>
                    </div>
                    <div className="rzr-under-section text-center">
                        <p className='text-white paragraphtext mt-0 mt-lg-2 text-wrap mb-1'>
                            PLAYERS CAN ALSO WIN<br className='d-md-none d-block' /> A CORSAIR ULTIMATE PC GAMING SET-UP
                        </p>
                        <p className='text-white paragraphtext mt-0 mt-lg-2 text-wrap mb-5'>
                            READY TO TURN ANY DESK<br className='d-md-none d-block' /> INTO A BLACK OPS 6 BATTLE STATION
                        </p>
                    </div>
                </Col>
                <Col xs={12} lg={9} className='mx-auto'>
                    <div className="image-container position-relative">
                        <Image className='bundle mb-5' src="https://d2bxnt3cp18qf5.cloudfront.net/setup.webp" width="100%" />
                    </div>
                    {/* <Row>
                        <div className="text-center rzr-section mb-2">
                            <h1 className='text-white headingtext text-wrap mb-1'>
                                CORSAIR BUNDLE INCLUDES:
                            </h1>
                        </div>
                        <Col xs={12} lg={6} >
                            <ul>
                                {firstColumnItems.map((item, index) => (
                                    <li style={{ color: "#f96800" }} className='setup-items paragraphtext  mb-2' key={index}>{item}</li>
                                ))}
                            </ul>
                        </Col>
                        <Col xs={12} lg={6}>
                            <ul>
                                {secondColumnItems.map((item, index) => (
                                    <li style={{ color: "#f96800" }} className='setup-items paragraphtext  mb-2' key={index + 5}>{item}</li>
                                ))}
                            </ul>
                        </Col>
                    </Row> */}
                </Col>
            </Container>
        </>
    );
};

export default GameBundle;
